module.exports = __webpack_public_path__ + "img/MANGO_PCB.d9a9a75a.png";